import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../library/button/button';
import ProductSwatchDescription from '../product-swatch-description/product-swatch-description';

import { useProductSwatchSelection } from '../../shared/hooks/hooks';

import { ProductSwatchesProp } from '../../shared/utils/prop-types/prop-types';

import './product-swatch-selection.scss';

function ProductSwatchSelection(props) {
  const {
    availableSwatches,
    productCode,
    swatches,
    onSwatchChange,
    className,
    productFinish: propsProductFinish,
    selectedSwatch: propsSelectedSwatch
  } = props;

  const { selectedSwatch: internalSelectedSwatch, saveSelectedSwatch } =
    useProductSwatchSelection(productCode, swatches);
  const selectedSwatch = propsSelectedSwatch || internalSelectedSwatch;
  const productFinish = selectedSwatch?.vendorFinish || propsProductFinish;
  const availableSwatchesSet = Array.isArray(availableSwatches)
    ? new Set(availableSwatches.map(c => c?.code))
    : new Set();

  function swatchChange(swatch) {
    saveSelectedSwatch(swatch);

    if (onSwatchChange) {
      onSwatchChange(swatch);
    }
  }

  if (!Array.isArray(swatches) || swatches.length <= 0) {
    return (
      <ProductSwatchDescription
        color={selectedSwatch?.altText}
        finish={productFinish}
      />
    );
  }

  return (
    <div className={className} styleName="container">
      <ProductSwatchDescription
        color={selectedSwatch?.altText}
        finish={productFinish}
      />
      <div className="swatches-container" styleName="swatches-container">
        {swatches.map((swatch, i) => {
          const { code, hexCode, linkUrl } = swatch || {};
          const swatchId = code || hexCode;
          const selectedSwatchId =
            selectedSwatch?.code || selectedSwatch?.hexCode;

          return (
            <Button
              key={`swatch-${i}`}
              onClick={() => swatchChange(swatch)}
              style={{
                backgroundColor: !linkUrl && hexCode ? hexCode : 'none',
                backgroundImage: `url(${linkUrl})`
              }}
              styleName={`swatch ${
                selectedSwatchId === swatchId ? 'selected' : 'not-selected'
              }`}
              tabIndex={0}
              type="button"
            >
              {availableSwatchesSet.size > 0 &&
                code &&
                !availableSwatchesSet.has(code) && (
                  <div styleName="swatch-not-available" />
                )}
            </Button>
          );
        })}
      </div>
    </div>
  );
}

ProductSwatchSelection.propTypes = {
  availableSwatches: PropTypes.array,
  className: PropTypes.string,
  onSwatchChange: PropTypes.func,
  productCode: PropTypes.string,
  productFinish: PropTypes.string,
  selectedSwatch: PropTypes.object,
  swatches: ProductSwatchesProp
};

export default ProductSwatchSelection;
